export const SMART_ID_POLLING_RESULT = {
  SUCCESS: 'success',
  ERROR: 'error', 
  EXPIRED: 'expired',
  CONTINUE: 'continue'
};

export const SMART_ID_EVENTS = {
  STATUS_CHANGED: 'smartIdStatusChanged'
}; 